// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27a%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%271.34%27 numOctaves=%274%27 stitchTiles=%27stitch%27%3E%3C/feTurbulence%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23a%29%27 opacity=%270.2%27%3E%3C/rect%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg width=%2713%27 height=%2713%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M0 11.5004C0 13.0004 2 13.0004 2 13.0004H12H13V0.00036329L12.5 0C12.5 0 11.977 2.09572 11.8581 2.50033C11.6075 3.35237 10.9149 4.22374 9 5.50036C6 7.50036 0 10.0004 0 11.5004Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 stroke=%27black%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg transform-origin=%27center%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279.5%27 fill=%27none%27 stroke-width=%273%27 stroke-linecap=%27round%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 from=%270 12 12%27 to=%27360 12 12%27 dur=%272s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dasharray%27 values=%270,150;42,150;42,150%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dashoffset%27 values=%270;-16;-59%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27currentColor%27 class=%27size-4%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z%27 clip-rule=%27evenodd%27 /%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:where(:root),:root:has(input.theme-controller[value=light]:checked),[data-theme=light] {
  color-scheme: light;
  --color-base-100: oklch(100% 0 0);
  --color-base-200: oklch(98% 0 0);
  --color-base-300: oklch(95% 0 0);
  --color-base-content: oklch(21% 0.006 285.885);
  --color-primary: oklch(45% 0.24 277.023);
  --color-primary-content: oklch(93% 0.034 272.788);
  --color-secondary: oklch(65% 0.241 354.308);
  --color-secondary-content: oklch(94% 0.028 342.258);
  --color-accent: oklch(77% 0.152 181.912);
  --color-accent-content: oklch(38% 0.063 188.416);
  --color-neutral: oklch(14% 0.005 285.823);
  --color-neutral-content: oklch(92% 0.004 286.32);
  --color-info: oklch(74% 0.16 232.661);
  --color-info-content: oklch(29% 0.066 243.157);
  --color-success: oklch(76% 0.177 163.223);
  --color-success-content: oklch(37% 0.077 168.94);
  --color-warning: oklch(82% 0.189 84.429);
  --color-warning-content: oklch(41% 0.112 45.904);
  --color-error: oklch(71% 0.194 13.428);
  --color-error-content: oklch(27% 0.105 12.094);
  --radius-selector: 0.5rem;
  --radius-field: 0.25rem;
  --radius-box: 0.5rem;
  --size-selector: 0.25rem;
  --size-field: 0.25rem;
  --border: 1px;
  --depth: 1;
  --noise: 0;
}

@media (prefers-color-scheme: dark) {

  :root {
    color-scheme: dark;
    --color-base-100: oklch(25.33% 0.016 252.42);
    --color-base-200: oklch(23.26% 0.014 253.1);
    --color-base-300: oklch(21.15% 0.012 254.09);
    --color-base-content: oklch(97.807% 0.029 256.847);
    --color-primary: oklch(58% 0.233 277.117);
    --color-primary-content: oklch(96% 0.018 272.314);
    --color-secondary: oklch(65% 0.241 354.308);
    --color-secondary-content: oklch(94% 0.028 342.258);
    --color-accent: oklch(77% 0.152 181.912);
    --color-accent-content: oklch(38% 0.063 188.416);
    --color-neutral: oklch(14% 0.005 285.823);
    --color-neutral-content: oklch(92% 0.004 286.32);
    --color-info: oklch(74% 0.16 232.661);
    --color-info-content: oklch(29% 0.066 243.157);
    --color-success: oklch(76% 0.177 163.223);
    --color-success-content: oklch(37% 0.077 168.94);
    --color-warning: oklch(82% 0.189 84.429);
    --color-warning-content: oklch(41% 0.112 45.904);
    --color-error: oklch(71% 0.194 13.428);
    --color-error-content: oklch(27% 0.105 12.094);
    --radius-selector: 0.5rem;
    --radius-field: 0.25rem;
    --radius-box: 0.5rem;
    --size-selector: 0.25rem;
    --size-field: 0.25rem;
    --border: 1px;
    --depth: 1;
    --noise: 0;
  }
}

:root:has(input.theme-controller[value=light]:checked),[data-theme=light] {
  color-scheme: light;
  --color-base-100: oklch(100% 0 0);
  --color-base-200: oklch(98% 0 0);
  --color-base-300: oklch(95% 0 0);
  --color-base-content: oklch(21% 0.006 285.885);
  --color-primary: oklch(45% 0.24 277.023);
  --color-primary-content: oklch(93% 0.034 272.788);
  --color-secondary: oklch(65% 0.241 354.308);
  --color-secondary-content: oklch(94% 0.028 342.258);
  --color-accent: oklch(77% 0.152 181.912);
  --color-accent-content: oklch(38% 0.063 188.416);
  --color-neutral: oklch(14% 0.005 285.823);
  --color-neutral-content: oklch(92% 0.004 286.32);
  --color-info: oklch(74% 0.16 232.661);
  --color-info-content: oklch(29% 0.066 243.157);
  --color-success: oklch(76% 0.177 163.223);
  --color-success-content: oklch(37% 0.077 168.94);
  --color-warning: oklch(82% 0.189 84.429);
  --color-warning-content: oklch(41% 0.112 45.904);
  --color-error: oklch(71% 0.194 13.428);
  --color-error-content: oklch(27% 0.105 12.094);
  --radius-selector: 0.5rem;
  --radius-field: 0.25rem;
  --radius-box: 0.5rem;
  --size-selector: 0.25rem;
  --size-field: 0.25rem;
  --border: 1px;
  --depth: 1;
  --noise: 0;
}

:root:has(input.theme-controller[value=dark]:checked),[data-theme=dark] {
  color-scheme: dark;
  --color-base-100: oklch(25.33% 0.016 252.42);
  --color-base-200: oklch(23.26% 0.014 253.1);
  --color-base-300: oklch(21.15% 0.012 254.09);
  --color-base-content: oklch(97.807% 0.029 256.847);
  --color-primary: oklch(58% 0.233 277.117);
  --color-primary-content: oklch(96% 0.018 272.314);
  --color-secondary: oklch(65% 0.241 354.308);
  --color-secondary-content: oklch(94% 0.028 342.258);
  --color-accent: oklch(77% 0.152 181.912);
  --color-accent-content: oklch(38% 0.063 188.416);
  --color-neutral: oklch(14% 0.005 285.823);
  --color-neutral-content: oklch(92% 0.004 286.32);
  --color-info: oklch(74% 0.16 232.661);
  --color-info-content: oklch(29% 0.066 243.157);
  --color-success: oklch(76% 0.177 163.223);
  --color-success-content: oklch(37% 0.077 168.94);
  --color-warning: oklch(82% 0.189 84.429);
  --color-warning-content: oklch(41% 0.112 45.904);
  --color-error: oklch(71% 0.194 13.428);
  --color-error-content: oklch(27% 0.105 12.094);
  --radius-selector: 0.5rem;
  --radius-field: 0.25rem;
  --radius-box: 0.5rem;
  --size-selector: 0.25rem;
  --size-field: 0.25rem;
  --border: 1px;
  --depth: 1;
  --noise: 0;
}

@property --radialprogress {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 0%;
}

:root {
  scrollbar-color: color-mix(in oklch, currentColor 35%, #0000) #0000;
}

:root:has( .modal-open, .modal[open], .modal:target, .modal-toggle:checked, .drawer:not([class*="drawer-open"]) > .drawer-toggle:checked ) {
  overflow: hidden;
}

:root, [data-theme] {
  background-color: var(--root-bg, var(--color-base-100));
  color: var(--color-base-content);
}

:root {
  --fx-noise: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chat {
  --mask-chat: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

:where( :root:has( .modal-open, .modal[open], .modal:target, .modal-toggle:checked, .drawer:not(.drawer-open) > .drawer-toggle:checked ) ) {
  scrollbar-gutter: stable;
  background-image: linear-gradient(var(--color-base-100), var(--color-base-100));
  --root-bg: color-mix(in srgb, var(--color-base-100), oklch(0% 0 0) 40%);
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@keyframes skeleton {

  0% {
    background-position: 150%;
  }

  100% {
    background-position: -50%;
  }
}
.\\!loading {
  pointer-events: none !important;
  display: inline-block !important;
  aspect-ratio: 1 / 1 !important;
  background-color: currentColor !important;
  vertical-align: middle !important;
  width: calc(var(--size-selector, 0.25rem) * 6) !important;
  mask-size: 100% !important;
  mask-repeat: no-repeat !important;
  mask-position: center !important;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}
.loading {
  pointer-events: none;
  display: inline-block;
  aspect-ratio: 1 / 1;
  background-color: currentColor;
  vertical-align: middle;
  width: calc(var(--size-selector, 0.25rem) * 6);
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loading-spinner {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loading-lg {
  width: calc(var(--size-selector, 0.25rem) * 7);
}
.progress {
  position: relative;
  height: calc(0.25rem * 2);
  width: 100%;
  appearance: none;
  overflow: hidden;
  border-radius: var(--radius-box);
  background-color: color-mix(in oklab, currentColor 20%, transparent);
  color: var(--color-base-content);
}
.progress:indeterminate {
  background-image: repeating-linear-gradient( 90deg, currentColor -1%, currentColor 10%, #0000 10%, #0000 90% );
  background-size: 200%;
  background-position-x: 15%;
  animation: progress 5s ease-in-out infinite;
}
@supports (-moz-appearance: none) {

  .progress:indeterminate::-moz-progress-bar {
    background-color: transparent;
    background-image: repeating-linear-gradient( 90deg, currentColor -1%, currentColor 10%, #0000 10%, #0000 90% );
    background-size: 200%;
    background-position-x: 15%;
    animation: progress 5s ease-in-out infinite;
  }

  .progress::-moz-progress-bar {
    border-radius: var(--radius-box);
    background-color: currentColor;
  }
}
@supports (-webkit-appearance: none) {

  .progress::-webkit-progress-bar {
    border-radius: var(--radius-box);
    background-color: transparent;
  }

  .progress::-webkit-progress-value {
    border-radius: var(--radius-box);
    background-color: currentColor;
  }
}
@keyframes progress {

  50% {
    background-position-x: -115%;
  }
}
:where(.btn) {
  width: unset;
}
.btn {
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: calc(0.25rem * 1.5);
  text-align: center;
  vertical-align: middle;
  outline-offset: 2px;
  webkit-user-select: none;
  -webkit-user-select: none;
          user-select: none;
  padding-inline: var(--btn-p);
  color: var(--btn-fg);
  --tw-prose-links: var(--btn-fg);
  height: var(--size);
  font-size: var(--fontsize, 0.875rem);
  font-weight: 600;
  outline-color: var(--btn-color, var(--color-base-content));
  transition-property: color, background-color, border-color, box-shadow;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 0.2s;
  border-start-start-radius: var(--join-ss, var(--radius-field));
  border-start-end-radius: var(--join-se, var(--radius-field));
  border-end-start-radius: var(--join-es, var(--radius-field));
  border-end-end-radius: var(--join-ee, var(--radius-field));
  background-color: var(--btn-bg);
  background-size: auto, calc(var(--noise) * 100%);
  background-image: none, var(--btn-noise);
  border-width: var(--border);
  border-style: solid;
  border-color: var(--btn-border);
  text-shadow: 0 0.5px oklch(100% 0 0 / calc(var(--depth) * 0.15));
  box-shadow: 0 0.5px 0 0.5px oklch(100% 0 0 / calc(var(--depth) * 6%)) inset, var(--btn-shadow);
  --size: calc(var(--size-field, 0.25rem) * 10);
  --btn-bg: var(--btn-color, var(--color-base-200));
  --btn-fg: var(--color-base-content);
  --btn-p: 1rem;
  --btn-border: color-mix(in oklab, var(--btn-bg), #000 calc(var(--depth) * 5%));
  --btn-shadow: 0 3px 2px -2px color-mix(in oklab, var(--btn-bg) calc(var(--depth) * 30%), #0000),
    0 4px 3px -2px color-mix(in oklab, var(--btn-bg) calc(var(--depth) * 30%), #0000);
  --btn-noise: var(--fx-noise);
}
.prose .btn {
  text-decoration-line: none;
}
@media (hover: hover) {

  .btn:hover {
    --btn-bg: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 7%);
  }
}
.btn:focus-visible {
  outline-width: 2px;
  outline-style: solid;
}
.btn:active:not(.btn-active) {
  translate: 0 0.5px;
  --btn-bg: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 5%);
  --btn-border: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 7%);
  --btn-shadow: 0 0 0 0 oklch(0% 0 0/0), 0 0 0 0 oklch(0% 0 0/0);
}
.btn:is(:disabled, [disabled], .btn-disabled):not(.btn-link, .btn-ghost) {
  background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
  box-shadow: none;
}
.btn:is(:disabled, [disabled], .btn-disabled) {
  pointer-events: none;
  --btn-border: #0000;
  --btn-noise: none;
  --btn-fg: color-mix(in oklch, var(--color-base-content) 20%, #0000);
}
@media (hover: hover) {

  .btn:is(:disabled, [disabled], .btn-disabled):hover {
    pointer-events: none;
    background-color: color-mix(in oklab, var(--color-neutral) 20%, transparent);
    --btn-border: #0000;
    --btn-fg: color-mix(in oklch, var(--color-base-content) 20%, #0000);
  }
}
.btn:is(input[type="checkbox"], input[type="radio"]) {
  appearance: none;
}
.btn:is(input[type="checkbox"], input[type="radio"])::after {
  content: attr(aria-label);
}
.btn:where(input:checked:not(.filter .btn)) {
  --btn-color: var(--color-primary);
  --btn-fg: var(--color-primary-content);
  isolation: isolate;
}
.btn-ghost:not(.btn-active, :hover, :active:focus, :focus-visible) {
  --btn-shadow: "";
  --btn-bg: #0000;
  --btn-border: #0000;
  --btn-noise: none;
}
.btn-ghost:not(.btn-active, :hover, :active:focus, :focus-visible):not(:disabled, [disabled], .btn-disabled) {
  outline-color: currentColor;
  --btn-fg: currentColor;
}
.btn-sm {
  --fontsize: 0.75rem;
  --btn-p: 0.75rem;
  --size: calc(var(--size-field, 0.25rem) * 8);
}
.btn-circle {
  border-radius: calc(infinity * 1px);
  padding-inline: calc(0.25rem * 0);
  width: var(--size);
  height: var(--size);
}
.filter {
  display: flex;
  flex-wrap: wrap;
}
.filter input[type="radio"] {
  width: auto;
}
.filter input {
  overflow: hidden;
  opacity: 100%;
  scale: 1;
  transition: margin 0.1s, opacity 0.3s, padding 0.3s, border-width 0.1s;
}
.filter input:not(:last-child) {
  margin-inline-end: calc(0.25rem * 1);
}
.filter input.filter-reset {
  aspect-ratio: 1 / 1;
}
.filter input.filter-reset::after {
  content: "×";
}
.filter:not(:has(input:checked:not(.filter-reset))) .filter-reset, .filter:not(:has(input:checked:not(.filter-reset))) input[type="reset"] {
  scale: 0;
  border-width: 0;
  margin-inline: calc(0.25rem * 0);
  width: calc(0.25rem * 0);
  padding-inline: calc(0.25rem * 0);
  opacity: 0%;
}
.filter:has(input:checked:not(.filter-reset)) input:not(:checked, .filter-reset, input[type="reset"]) {
  scale: 0;
  border-width: 0;
  margin-inline: calc(0.25rem * 0);
  width: calc(0.25rem * 0);
  padding-inline: calc(0.25rem * 0);
  opacity: 0%;
}
.\\!input {
  cursor: text !important;
  border: var(--border) solid #0000 !important;
  position: relative !important;
  display: inline-flex !important;
  flex-shrink: 1 !important;
  appearance: none !important;
  align-items: center !important;
  gap: calc(0.25rem * 2) !important;
  background-color: var(--color-base-100) !important;
  padding-inline: calc(0.25rem * 3) !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: clamp(3rem, 20rem, 100%) !important;
  height: var(--size) !important;
  font-size: 0.875rem !important;
  border-start-start-radius: var(--join-ss, var(--radius-field)) !important;
  border-start-end-radius: var(--join-se, var(--radius-field)) !important;
  border-end-start-radius: var(--join-es, var(--radius-field)) !important;
  border-end-end-radius: var(--join-ee, var(--radius-field)) !important;
  border-color: var(--input-color) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset !important;
  --size: calc(var(--size-field, 0.25rem) * 10) !important;
  --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000) !important;
}
.input {
  cursor: text;
  border: var(--border) solid #0000;
  position: relative;
  display: inline-flex;
  flex-shrink: 1;
  appearance: none;
  align-items: center;
  gap: calc(0.25rem * 2);
  background-color: var(--color-base-100);
  padding-inline: calc(0.25rem * 3);
  vertical-align: middle;
  white-space: nowrap;
  width: clamp(3rem, 20rem, 100%);
  height: var(--size);
  font-size: 0.875rem;
  border-start-start-radius: var(--join-ss, var(--radius-field));
  border-start-end-radius: var(--join-se, var(--radius-field));
  border-end-start-radius: var(--join-es, var(--radius-field));
  border-end-end-radius: var(--join-ee, var(--radius-field));
  border-color: var(--input-color);
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
  --size: calc(var(--size-field, 0.25rem) * 10);
  --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
}
.\\!input:where(input) {
  display: inline-flex !important;
}
.input:where(input) {
  display: inline-flex;
}
.\\!input :where(input) {
  display: inline-flex !important;
  height: 100% !important;
  width: 100% !important;
  appearance: none !important;
  background-color: transparent !important;
  border: none !important;
}
.input :where(input) {
  display: inline-flex;
  height: 100%;
  width: 100%;
  appearance: none;
  background-color: transparent;
  border: none;
}
.\\!input :where(input):focus, .\\!input :where(input):focus-within {
  --tw-outline-style: none !important;
  outline-style: none !important;
}
.input :where(input):focus, .input :where(input):focus-within {
  --tw-outline-style: none;
  outline-style: none;
}
.\\!input :where(input):focus, .\\!input :where(input):focus-within {
  --tw-outline-style: none !important;
  outline-style: none !important;
}
@media (forced-colors: active) {

  .\\!input :where(input):focus, .\\!input :where(input):focus-within {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
  }

  .input :where(input):focus, .input :where(input):focus-within {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .\\!input :where(input):focus, .\\!input :where(input):focus-within {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
  }
}
.\\!input :where(input[type="date"]) {
  display: inline-block !important;
}
.input :where(input[type="date"]) {
  display: inline-block;
}
.\\!input:focus, .\\!input:focus-within {
  --input-color: var(--color-base-content) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) !important;
  outline: 2px solid var(--input-color) !important;
  outline-offset: 2px !important;
  isolation: isolate !important;
}
.input:focus, .input:focus-within {
  --input-color: var(--color-base-content);
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
  outline: 2px solid var(--input-color);
  outline-offset: 2px;
  isolation: isolate;
}
.\\!input:focus, .\\!input:focus-within {
  --input-color: var(--color-base-content) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) !important;
  outline: 2px solid var(--input-color) !important;
  outline-offset: 2px !important;
  isolation: isolate !important;
}
.\\!input:has(> input[disabled]), .\\!input:is(:disabled, [disabled]) {
  cursor: not-allowed !important;
  border-color: var(--color-base-200) !important;
  background-color: var(--color-base-200) !important;
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent) !important;
}
.input:has(> input[disabled]), .input:is(:disabled, [disabled]) {
  cursor: not-allowed;
  border-color: var(--color-base-200);
  background-color: var(--color-base-200);
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
}
.\\!input:has(> input[disabled]), .\\!input:is(:disabled, [disabled]) {
  cursor: not-allowed !important;
  border-color: var(--color-base-200) !important;
  background-color: var(--color-base-200) !important;
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent) !important;
}
.\\!input:has(> input[disabled])::placeholder, .\\!input:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent) !important;
}
.input:has(> input[disabled])::placeholder, .input:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
}
.\\!input:has(> input[disabled])::placeholder, .\\!input:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent) !important;
}
.\\!input:has(> input[disabled]), .\\!input:is(:disabled, [disabled]) {
  box-shadow: none !important;
}
.input:has(> input[disabled]), .input:is(:disabled, [disabled]) {
  box-shadow: none;
}
.\\!input:has(> input[disabled]), .\\!input:is(:disabled, [disabled]) {
  box-shadow: none !important;
}
.\\!input:has(> input[disabled]) > input[disabled] {
  cursor: not-allowed !important;
}
.input:has(> input[disabled]) > input[disabled] {
  cursor: not-allowed;
}
.\\!input::-webkit-date-and-time-value {
  text-align: inherit !important;
}
.input::-webkit-date-and-time-value {
  text-align: inherit;
}
.\\!input[type="number"]::-webkit-inner-spin-button {
  margin-block: calc(0.25rem * -3) !important;
  margin-inline-end: calc(0.25rem * -3) !important;
}
.input[type="number"]::-webkit-inner-spin-button {
  margin-block: calc(0.25rem * -3);
  margin-inline-end: calc(0.25rem * -3);
}
.\\!input::-webkit-calendar-picker-indicator {
  position: absolute !important;
  inset-inline-end: 0.75em !important;
}
.input::-webkit-calendar-picker-indicator {
  position: absolute;
  inset-inline-end: 0.75em;
}
.avatar-group :where(.avatar) {
  overflow: hidden;
  border-radius: calc(infinity * 1px);
  border: 4px solid var(--color-base-100);
}
.avatar {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.avatar > div {
  display: block;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}
.avatar img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@keyframes radio {

  0% {
    padding: 5px;
  }

  50% {
    padding: 3px;
  }
}
.label {
  display: inline-flex;
  align-items: center;
  gap: calc(0.25rem * 1.5);
  white-space: nowrap;
  color: color-mix(in oklab, currentColor 60%, transparent);
}
.label:has(input) {
  cursor: pointer;
}
.label:is(.input > *, .select > *) {
  display: flex;
  height: calc(100% - 0.5rem);
  align-items: center;
  padding-inline: calc(0.25rem * 3);
  white-space: nowrap;
  font-size: inherit;
}
.label:is(.\\!input > *, .select > *) {
  display: flex !important;
  height: calc(100% - 0.5rem) !important;
  align-items: center !important;
  padding-inline: calc(0.25rem * 3) !important;
  white-space: nowrap !important;
  font-size: inherit !important;
}
.label:is(.input > *, .select > *):first-child {
  margin-inline-start: calc(0.25rem * -3);
  margin-inline-end: calc(0.25rem * 3);
  border-inline-end: var(--border) solid color-mix(in oklab, currentColor 10%, #0000);
}
.label:is(.\\!input > *, .select > *):first-child {
  margin-inline-start: calc(0.25rem * -3) !important;
  margin-inline-end: calc(0.25rem * 3) !important;
  border-inline-end: var(--border) solid color-mix(in oklab, currentColor 10%, #0000) !important;
}
.label:is(.input > *, .select > *):last-child {
  margin-inline-start: calc(0.25rem * 3);
  margin-inline-end: calc(0.25rem * -3);
  border-inline-start: var(--border) solid color-mix(in oklab, currentColor 10%, #0000);
}
.label:is(.\\!input > *, .select > *):last-child {
  margin-inline-start: calc(0.25rem * 3) !important;
  margin-inline-end: calc(0.25rem * -3) !important;
  border-inline-start: var(--border) solid color-mix(in oklab, currentColor 10%, #0000) !important;
}
.status {
  display: inline-block;
  aspect-ratio: 1 / 1;
  width: calc(0.25rem * 2);
  height: calc(0.25rem * 2);
  border-radius: var(--radius-selector);
  background-color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  color: color-mix(in srgb, #000 30%, transparent);
}
@supports (color: color-mix(in lab, red, red)) {

  .status {
    color: color-mix(in oklab, var(--color-black) 30%, transparent);
  }
}
.status {
  background-image: radial-gradient( circle at 35% 30%, oklch(1 0 0 / calc(var(--depth) * 0.5)), #0000 );
  box-shadow: 0 2px 3px -1px color-mix(in oklab, currentColor calc(var(--depth) * 100%), #0000);
}
.steps {
  display: inline-grid;
  grid-auto-flow: column;
  overflow: hidden;
  overflow-x: auto;
  counter-reset: step;
  grid-auto-columns: 1fr;
}
.steps .step {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-columns: auto;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-rows: 40px 1fr;
  place-items: center;
  text-align: center;
  min-width: 4rem;
  --step-bg: var(--color-base-300);
  --step-fg: var(--color-base-content);
}
.steps .step:before {
  top: calc(0.25rem * 0);
  grid-column-start: 1;
  grid-row-start: 1;
  height: calc(0.25rem * 2);
  width: 100%;
  border: 1px solid;
  color: var(--step-bg);
  background-color: var(--step-bg);
  --tw-content: "";
  content: var(--tw-content);
  margin-inline-start: -100%;
}
.steps .step > .step-icon, .steps .step:not(:has(.step-icon)):after {
  content: counter(step);
  counter-increment: step;
  z-index: 1;
  color: var(--step-fg);
  background-color: var(--step-bg);
  border: 1px solid var(--step-bg);
  position: relative;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  height: calc(0.25rem * 8);
  width: calc(0.25rem * 8);
  place-items: center;
  place-self: center;
  border-radius: calc(infinity * 1px);
}
.steps .step:first-child:before {
  content: none;
}
.steps .step[data-content]:after {
  content: attr(data-content);
}
.steps .step-neutral + .step-neutral:before, .steps .step-neutral:after, .steps .step-neutral > .step-icon {
  --step-bg: var(--color-neutral);
  --step-fg: var(--color-neutral-content);
}
.steps .step-primary + .step-primary:before, .steps .step-primary:after, .steps .step-primary > .step-icon {
  --step-bg: var(--color-primary);
  --step-fg: var(--color-primary-content);
}
.steps .step-secondary + .step-secondary:before, .steps .step-secondary:after, .steps .step-secondary > .step-icon {
  --step-bg: var(--color-secondary);
  --step-fg: var(--color-secondary-content);
}
.steps .step-accent + .step-accent:before, .steps .step-accent:after, .steps .step-accent > .step-icon {
  --step-bg: var(--color-accent);
  --step-fg: var(--color-accent-content);
}
.steps .step-info + .step-info:before, .steps .step-info:after, .steps .step-info > .step-icon {
  --step-bg: var(--color-info);
  --step-fg: var(--color-info-content);
}
.steps .step-success + .step-success:before, .steps .step-success:after, .steps .step-success > .step-icon {
  --step-bg: var(--color-success);
  --step-fg: var(--color-success-content);
}
.steps .step-warning + .step-warning:before, .steps .step-warning:after, .steps .step-warning > .step-icon {
  --step-bg: var(--color-warning);
  --step-fg: var(--color-warning-content);
}
.steps .step-error + .step-error:before, .steps .step-error:after, .steps .step-error > .step-icon {
  --step-bg: var(--color-error);
  --step-fg: var(--color-error-content);
}
.steps-horizontal .step {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-columns: auto;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-rows: 40px 1fr;
  place-items: center;
  text-align: center;
  min-width: 4rem;
}
.steps-horizontal .step:before {
  height: calc(0.25rem * 2);
  width: 100%;
  translate: 0;
  content: "";
  margin-inline-start: -100%;
}
[dir="rtl"] .steps-horizontal .step:before {
  translate: 0;
}
.steps-vertical .step {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-columns: 40px 1fr;
  grid-template-rows: repeat(1, minmax(0, 1fr));
  grid-template-rows: auto;
  gap: 0.5rem;
  min-height: 4rem;
  justify-items: start;
}
.steps-vertical .step:before {
  height: 100%;
  width: calc(0.25rem * 2);
  translate: -50% -50%;
  margin-inline-start: 50%;
}
[dir="rtl"] .steps-vertical .step:before {
  translate: 50% -50%;
}
.dropdown {
  position: relative;
  display: inline-block;
  position-area: var(--anchor-v, bottom) var(--anchor-h, span-right);
}
.dropdown > *:not(summary):focus {
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .dropdown > *:not(summary):focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.dropdown .dropdown-content {
  position: absolute;
}
.dropdown:not(details, .dropdown-open, .dropdown-hover:hover, :focus-within) .dropdown-content {
  display: none;
  transform-origin: top;
  opacity: 0%;
  scale: 95%;
}
.dropdown[popover], .dropdown .dropdown-content {
  z-index: 999;
  animation: dropdown 0.2s;
  transition-property: opacity, scale, display;
  transition-behavior: allow-discrete;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@starting-style {

  .dropdown[popover], .dropdown .dropdown-content {
    scale: 95%;
    opacity: 0;
  }
}
.dropdown.dropdown-open > [tabindex]:first-child, .dropdown:not(.dropdown-hover):focus > [tabindex]:first-child, .dropdown:focus-within > [tabindex]:first-child {
  pointer-events: none;
}
.dropdown.dropdown-open .dropdown-content, .dropdown:not(.dropdown-hover):focus .dropdown-content, .dropdown:focus-within .dropdown-content {
  opacity: 100%;
}
.dropdown.dropdown-hover:hover .dropdown-content {
  opacity: 100%;
  scale: 100%;
}
.dropdown:is(details) summary::-webkit-details-marker {
  display: none;
}
.dropdown.dropdown-open .dropdown-content, .dropdown:focus .dropdown-content, .dropdown:focus-within .dropdown-content {
  scale: 100%;
}
.dropdown:where([popover]) {
  background: #0000;
}
.dropdown[popover] {
  position: fixed;
  color: inherit;
}
@supports not (position-area: bottom) {

  .dropdown[popover] {
    margin: auto;
  }

  .dropdown[popover].dropdown-open:not(:popover-open) {
    display: none;
    transform-origin: top;
    opacity: 0%;
    scale: 95%;
  }

  .dropdown[popover]::backdrop {
    background-color: color-mix(in oklab, #000 30%, #0000);
  }
}
.dropdown[popover]:not(.dropdown-open, :popover-open) {
  display: none;
  transform-origin: top;
  opacity: 0%;
  scale: 95%;
}
.dropdown-start :where(.dropdown-content) {
  inset-inline-end: auto;
}
.dropdown-start.dropdown-left .dropdown-content {
  top: calc(0.25rem * 0);
  bottom: auto;
}
.dropdown-start.dropdown-right .dropdown-content {
  top: calc(0.25rem * 0);
  bottom: auto;
}
.dropdown-center :where(.dropdown-content) {
  inset-inline-end: calc(1/2 * 100%);
  translate: 50% 0;
}
[dir="rtl"] .dropdown-center :where(.dropdown-content) {
  translate: -50% 0;
}
.dropdown-center.dropdown-left .dropdown-content {
  top: auto;
  bottom: calc(1/2 * 100%);
  translate: 0 50%;
}
.dropdown-center.dropdown-right .dropdown-content {
  top: auto;
  bottom: calc(1/2 * 100%);
  translate: 0 50%;
}
.dropdown-end {
  --anchor-h: span-left;
}
.dropdown-end :where(.dropdown-content) {
  inset-inline-end: calc(0.25rem * 0);
  translate: 0 0;
}
.dropdown-end.dropdown-left {
  --anchor-h: left;
  --anchor-v: span-top;
}
.dropdown-end.dropdown-left .dropdown-content {
  top: auto;
  bottom: calc(0.25rem * 0);
}
.dropdown-end.dropdown-right {
  --anchor-h: right;
  --anchor-v: span-top;
}
.dropdown-end.dropdown-right .dropdown-content {
  top: auto;
  bottom: calc(0.25rem * 0);
}
.dropdown-left .dropdown-content {
  inset-inline-end: 100%;
  top: calc(0.25rem * 0);
  bottom: auto;
  transform-origin: right;
}
.dropdown-right .dropdown-content {
  inset-inline-start: 100%;
  top: calc(0.25rem * 0);
  bottom: auto;
  transform-origin: left;
}
.dropdown-bottom .dropdown-content {
  top: 100%;
  bottom: auto;
  transform-origin: top;
}
.dropdown-top .dropdown-content {
  top: auto;
  bottom: 100%;
  transform-origin: bottom;
}
@keyframes dropdown {

  0% {
    opacity: 0;
  }
}
.list {
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
}
.list :where(.list-row) {
  --list-grid-cols: minmax(0, auto) 1fr;
  position: relative;
  display: grid;
  grid-auto-flow: column;
  gap: calc(0.25rem * 4);
  border-radius: var(--radius-box);
  padding: calc(0.25rem * 4);
  word-break: break-word;
  grid-template-columns: var(--list-grid-cols);
}
.list :where(.list-row):has(.list-col-grow:nth-child(1)) {
  --list-grid-cols: 1fr;
}
.list :where(.list-row):has(.list-col-grow:nth-child(2)) {
  --list-grid-cols: minmax(0, auto) 1fr;
}
.list :where(.list-row):has(.list-col-grow:nth-child(3)) {
  --list-grid-cols: minmax(0, auto) minmax(0, auto) 1fr;
}
.list :where(.list-row):has(.list-col-grow:nth-child(4)) {
  --list-grid-cols: minmax(0, auto) minmax(0, auto) minmax(0, auto) 1fr;
}
.list :where(.list-row):has(.list-col-grow:nth-child(5)) {
  --list-grid-cols: minmax(0, auto) minmax(0, auto) minmax(0, auto) minmax(0, auto) 1fr;
}
.list :where(.list-row):has(.list-col-grow:nth-child(6)) {
  --list-grid-cols: minmax(0, auto) minmax(0, auto) minmax(0, auto) minmax(0, auto)
        minmax(0, auto) 1fr;
}
.list :where(.list-row) :not(.list-col-wrap) {
  grid-row-start: 1;
}
.list > :not(:last-child).list-row:after, .list > :not(:last-child) .list-row:after {
  content: "";
  border-bottom: var(--border) solid;
  inset-inline: var(--radius-box);
  position: absolute;
  bottom: calc(0.25rem * 0);
  border-color: color-mix(in oklab, var(--color-base-content) 5%, transparent);
}
.checkbox {
  border: var(--border) solid var(--input-color, color-mix(in oklab, var(--color-base-content) 20%, #0000));
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  appearance: none;
  border-radius: var(--radius-selector);
  padding: calc(0.25rem * 1);
  vertical-align: middle;
  color: var(--color-base-content);
  box-shadow: 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 0 #0000 inset, 0 0 #0000;
  transition: background-color 0.2s, box-shadow 0.2s;
  --size: calc(var(--size-selector, 0.25rem) * 6);
  width: var(--size);
  height: var(--size);
  background-size: auto, calc(var(--noise) * 100%);
  background-image: none, var(--fx-noise);
}
.checkbox:before {
  --tw-content: "";
  content: var(--tw-content);
  display: block;
  width: 100%;
  height: 100%;
  rotate: 45deg;
  background-color: currentColor;
  opacity: 0%;
  transition: clip-path 0.3s, opacity 0.1s, rotate 0.3s, translate 0.3s;
  transition-delay: 0.1s;
  clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 80%, 70% 80%, 70% 100%);
  box-shadow: 0px 3px 0 0px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
  font-size: 1rem;
  line-height: 0.75;
}
.checkbox:focus-visible {
  outline: 2px solid var(--input-color, currentColor);
  outline-offset: 2px;
}
.checkbox:checked, .checkbox[aria-checked="true"] {
  background-color: var(--input-color, #0000);
  box-shadow: 0 0 #0000 inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1));
}
.checkbox:checked:before, .checkbox[aria-checked="true"]:before {
  clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 0%, 70% 0%, 70% 100%);
  opacity: 100%;
}
@media (forced-colors: active) {

  .checkbox:checked:before, .checkbox[aria-checked="true"]:before {
    rotate: 0deg;
    background-color: transparent;
    --tw-content: "✔︎";
    clip-path: none;
  }
}
@media print {

  .checkbox:checked:before, .checkbox[aria-checked="true"]:before {
    rotate: 0deg;
    background-color: transparent;
    --tw-content: "✔︎";
    clip-path: none;
  }
}
.checkbox:indeterminate:before {
  rotate: 0deg;
  opacity: 100%;
  translate: 0 -35%;
  clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 80%, 80% 80%, 80% 100%);
}
.checkbox:disabled {
  cursor: not-allowed;
  opacity: 20%;
}
@keyframes rating {

  0%, 40% {
    scale: 1.1;
    filter: brightness(1.05) contrast(1.05);
  }
}
.toggle {
  border: var(--border) solid currentColor;
  color: var(--input-color);
  position: relative;
  display: inline-grid;
  flex-shrink: 0;
  cursor: pointer;
  appearance: none;
  place-content: center;
  vertical-align: middle;
  webkit-user-select: none;
  -webkit-user-select: none;
          user-select: none;
  grid-template-columns: 0fr 1fr 1fr;
  --radius-selector-max: calc(
    var(--radius-selector) + var(--radius-selector) + var(--radius-selector)
  );
  border-radius: calc( var(--radius-selector) + min(var(--toggle-p), var(--radius-selector-max)) + min(var(--border), var(--radius-selector-max)) );
  padding: var(--toggle-p);
  box-shadow: 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000) inset;
  transition: color 0.3s, grid-template-columns 0.2s;
  --input-color: color-mix(in oklab, var(--color-base-content) 50%, #0000);
  --toggle-p: 0.1875rem;
  --size: calc(var(--size-selector, 0.25rem) * 6);
  width: calc((var(--size) * 2) - (var(--border) + var(--toggle-p)) * 2);
  height: var(--size);
}
.toggle > * {
  z-index: 1;
  grid-column: span 1 / span 1;
  grid-column-start: 2;
  grid-row-start: 1;
  height: 100%;
  cursor: pointer;
  appearance: none;
  background-color: transparent;
  padding: calc(0.25rem * 0.5);
  transition: opacity 0.2s, rotate 0.4s;
  border: none;
}
.toggle > *:focus {
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .toggle > *:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.toggle > *:nth-child(2) {
  color: var(--color-base-100);
  rotate: 0deg;
}
.toggle > *:nth-child(3) {
  color: var(--color-base-100);
  opacity: 0%;
  rotate: -15deg;
}
.toggle:has(:checked) > :nth-child(2) {
  opacity: 0%;
  rotate: 15deg;
}
.toggle:has(:checked) > :nth-child(3) {
  opacity: 100%;
  rotate: 0deg;
}
.toggle:before {
  position: relative;
  inset-inline-start: calc(0.25rem * 0);
  grid-column-start: 2;
  grid-row-start: 1;
  aspect-ratio: 1 / 1;
  height: 100%;
  border-radius: var(--radius-selector);
  background-color: currentColor;
  translate: 0;
  --tw-content: "";
  content: var(--tw-content);
  transition: background-color 0.1s, translate 0.2s, inset-inline-start 0.2s;
  box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000);
  background-size: auto, calc(var(--noise) * 100%);
  background-image: none, var(--fx-noise);
}
@media (forced-colors: active) {

  .toggle:before {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
    outline-offset: calc(1px * -1);
  }
}
@media print {

  .toggle:before {
    outline: 0.25rem solid;
    outline-offset: -1rem;
  }
}
.toggle:focus-visible, .toggle:has(:focus-visible) {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.toggle:checked, .toggle[aria-checked="true"], .toggle:has(> input:checked) {
  grid-template-columns: 1fr 1fr 0fr;
  background-color: var(--color-base-100);
  --input-color: var(--color-base-content);
}
.toggle:checked:before, .toggle[aria-checked="true"]:before, .toggle:has(> input:checked):before {
  background-color: currentColor;
}
@starting-style {

  .toggle:checked:before, .toggle[aria-checked="true"]:before, .toggle:has(> input:checked):before {
    opacity: 0;
  }
}
.toggle:indeterminate {
  grid-template-columns: 0.5fr 1fr 0.5fr;
}
.toggle:disabled {
  cursor: not-allowed;
  opacity: 30%;
}
.toggle:disabled:before {
  background-color: transparent;
  border: var(--border) solid currentColor;
}
.\\!textarea {
  border: var(--border) solid #0000 !important;
  min-height: calc(0.25rem * 20) !important;
  flex-shrink: 1 !important;
  appearance: none !important;
  border-radius: var(--radius-field) !important;
  background-color: var(--color-base-100) !important;
  padding-block: calc(0.25rem * 2) !important;
  vertical-align: middle !important;
  width: clamp(3rem, 20rem, 100%) !important;
  padding-inline-start: 0.75rem !important;
  padding-inline-end: 0.75rem !important;
  font-size: 0.875rem !important;
  border-color: var(--input-color) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset !important;
  --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000) !important;
}
.textarea {
  border: var(--border) solid #0000;
  min-height: calc(0.25rem * 20);
  flex-shrink: 1;
  appearance: none;
  border-radius: var(--radius-field);
  background-color: var(--color-base-100);
  padding-block: calc(0.25rem * 2);
  vertical-align: middle;
  width: clamp(3rem, 20rem, 100%);
  padding-inline-start: 0.75rem;
  padding-inline-end: 0.75rem;
  font-size: 0.875rem;
  border-color: var(--input-color);
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
  --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
}
.\\!textarea textarea {
  appearance: none !important;
  background-color: transparent !important;
  border: none !important;
}
.textarea textarea {
  appearance: none;
  background-color: transparent;
  border: none;
}
.\\!textarea textarea:focus, .\\!textarea textarea:focus-within {
  --tw-outline-style: none !important;
  outline-style: none !important;
}
.textarea textarea:focus, .textarea textarea:focus-within {
  --tw-outline-style: none;
  outline-style: none;
}
.\\!textarea textarea:focus, .\\!textarea textarea:focus-within {
  --tw-outline-style: none !important;
  outline-style: none !important;
}
@media (forced-colors: active) {

  .\\!textarea textarea:focus, .\\!textarea textarea:focus-within {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
  }

  .textarea textarea:focus, .textarea textarea:focus-within {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .\\!textarea textarea:focus, .\\!textarea textarea:focus-within {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
  }
}
.\\!textarea:focus, .\\!textarea:focus-within {
  --input-color: var(--color-base-content) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) !important;
  outline: 2px solid var(--input-color) !important;
  outline-offset: 2px !important;
  isolation: isolate !important;
}
.textarea:focus, .textarea:focus-within {
  --input-color: var(--color-base-content);
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
  outline: 2px solid var(--input-color);
  outline-offset: 2px;
  isolation: isolate;
}
.\\!textarea:focus, .\\!textarea:focus-within {
  --input-color: var(--color-base-content) !important;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) !important;
  outline: 2px solid var(--input-color) !important;
  outline-offset: 2px !important;
  isolation: isolate !important;
}
.\\!textarea:has(> textarea[disabled]), .\\!textarea:is(:disabled, [disabled]) {
  cursor: not-allowed !important;
  border-color: var(--color-base-200) !important;
  background-color: var(--color-base-200) !important;
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent) !important;
}
.textarea:has(> textarea[disabled]), .textarea:is(:disabled, [disabled]) {
  cursor: not-allowed;
  border-color: var(--color-base-200);
  background-color: var(--color-base-200);
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
}
.\\!textarea:has(> textarea[disabled]), .\\!textarea:is(:disabled, [disabled]) {
  cursor: not-allowed !important;
  border-color: var(--color-base-200) !important;
  background-color: var(--color-base-200) !important;
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent) !important;
}
.\\!textarea:has(> textarea[disabled])::placeholder, .\\!textarea:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent) !important;
}
.textarea:has(> textarea[disabled])::placeholder, .textarea:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
}
.\\!textarea:has(> textarea[disabled])::placeholder, .\\!textarea:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent) !important;
}
.\\!textarea:has(> textarea[disabled]), .\\!textarea:is(:disabled, [disabled]) {
  box-shadow: none !important;
}
.textarea:has(> textarea[disabled]), .textarea:is(:disabled, [disabled]) {
  box-shadow: none;
}
.\\!textarea:has(> textarea[disabled]), .\\!textarea:is(:disabled, [disabled]) {
  box-shadow: none !important;
}
.\\!textarea:has(> textarea[disabled]) > textarea[disabled] {
  cursor: not-allowed !important;
}
.textarea:has(> textarea[disabled]) > textarea[disabled] {
  cursor: not-allowed;
}
.indicator {
  position: relative;
  display: inline-flex;
  width: max-content;
}
.indicator :where(.indicator-item) {
  z-index: 1;
  position: absolute;
  white-space: nowrap;
  top: var(--inidicator-t, 0);
  bottom: var(--inidicator-b, auto);
  left: var(--inidicator-s, auto);
  right: var(--inidicator-e, 0);
  translate: var(--inidicator-x, 50%) var(--indicator-y, -50%);
}
.mockup-browser .mockup-browser-toolbar .\\!input {
  margin-inline: auto !important;
  display: flex !important;
  height: 100% !important;
  align-items: center !important;
  gap: calc(0.25rem * 2) !important;
  overflow: hidden !important;
  background-color: var(--color-base-200) !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  font-size: 0.75rem !important;
  direction: ltr !important;
}
.mockup-browser .mockup-browser-toolbar .input {
  margin-inline: auto;
  display: flex;
  height: 100%;
  align-items: center;
  gap: calc(0.25rem * 2);
  overflow: hidden;
  background-color: var(--color-base-200);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  direction: ltr;
}
.mockup-browser .mockup-browser-toolbar .\\!input:before {
  content: "" !important;
  width: calc(0.25rem * 4) !important;
  height: calc(0.25rem * 4) !important;
  opacity: 30% !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}
.mockup-browser .mockup-browser-toolbar .input:before {
  content: "";
  width: calc(0.25rem * 4);
  height: calc(0.25rem * 4);
  opacity: 30%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@keyframes toast {

  0% {
    scale: 0.9;
    opacity: 0;
  }

  100% {
    scale: 1;
    opacity: 1;
  }
}
.menu {
  display: flex;
  width: fit-content;
  flex-direction: column;
  flex-wrap: wrap;
  padding: calc(0.25rem * 2);
  --menu-active-fg: var(--color-neutral-content);
  --menu-active-bg: var(--color-neutral);
  font-size: 0.875rem;
}
.menu :where(li ul) {
  position: relative;
  margin-inline-start: calc(0.25rem * 4);
  padding-inline-start: calc(0.25rem * 2);
  white-space: nowrap;
}
.menu :where(li ul):before {
  position: absolute;
  inset-inline-start: calc(0.25rem * 0);
  top: calc(0.25rem * 3);
  bottom: calc(0.25rem * 3);
  background-color: var(--color-base-content);
  opacity: 10%;
  width: var(--border);
  content: "";
}
.menu :where(li > .menu-dropdown:not(.menu-dropdown-show)) {
  display: none;
}
.menu :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)), .menu :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
  display: grid;
  grid-auto-flow: column;
  align-content: flex-start;
  align-items: center;
  gap: calc(0.25rem * 2);
  border-radius: var(--radius-field);
  padding-inline: calc(0.25rem * 3);
  padding-block: calc(0.25rem * 1.5);
  text-align: start;
  transition-property: color, background-color, box-shadow;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  grid-auto-columns: minmax(auto, max-content) auto max-content;
  text-wrap: balance;
  -webkit-user-select: none;
          user-select: none;
}
.menu :where(li > details > summary) {
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .menu :where(li > details > summary) {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.menu :where(li > details > summary)::-webkit-details-marker {
  display: none;
}
.menu :where(li > details > summary):after, .menu :where(li > .menu-dropdown-toggle):after {
  justify-self: flex-end;
  display: block;
  height: 0.375rem;
  width: 0.375rem;
  rotate: -135deg;
  translate: 0 -1px;
  transition-property: rotate, translate;
  transition-duration: 0.2s;
  content: "";
  transform-origin: 50% 50%;
  box-shadow: 2px 2px inset;
  pointer-events: none;
}
.menu :where(li > details[open] > summary):after, .menu :where(li > .menu-dropdown-toggle.menu-dropdown-show):after {
  rotate: 45deg;
  translate: 0 1px;
}
.menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title), li:not(.menu-title, .disabled) > details > summary:not(.menu-title) ):not(.menu-active, :active, .btn).menu-focus, .menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title), li:not(.menu-title, .disabled) > details > summary:not(.menu-title) ):not(.menu-active, :active, .btn):focus-visible {
  cursor: pointer;
  background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
  color: var(--color-base-content);
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title), li:not(.menu-title, .disabled) > details > summary:not(.menu-title) ):not(.menu-active, :active, .btn).menu-focus, .menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title), li:not(.menu-title, .disabled) > details > summary:not(.menu-title) ):not(.menu-active, :active, .btn):focus-visible {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title):not(.menu-active, :active, .btn):hover, li:not(.menu-title, .disabled) > details > summary:not(.menu-title):not(.menu-active, :active, .btn):hover ) {
  cursor: pointer;
  background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title):not(.menu-active, :active, .btn):hover, li:not(.menu-title, .disabled) > details > summary:not(.menu-title):not(.menu-active, :active, .btn):hover ) {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.menu :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title):not(.menu-active, :active, .btn):hover, li:not(.menu-title, .disabled) > details > summary:not(.menu-title):not(.menu-active, :active, .btn):hover ) {
  box-shadow: 0 1px oklch(0% 0 0 / 0.01) inset, 0 -1px oklch(100% 0 0 / 0.01) inset;
}
.menu :where(li:empty) {
  background-color: var(--color-base-content);
  opacity: 10%;
  margin: 0.5rem 1rem;
  height: 1px;
}
.menu :where(li) {
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
}
.menu :where(li) .badge {
  justify-self: flex-end;
}
.menu :where(li) > *:not(ul, .menu-title, details, .btn):active, .menu :where(li) > *:not(ul, .menu-title, details, .btn).menu-active, .menu :where(li) > details > summary:active {
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .menu :where(li) > *:not(ul, .menu-title, details, .btn):active, .menu :where(li) > *:not(ul, .menu-title, details, .btn).menu-active, .menu :where(li) > details > summary:active {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.menu :where(li) > *:not(ul, .menu-title, details, .btn):active, .menu :where(li) > *:not(ul, .menu-title, details, .btn).menu-active, .menu :where(li) > details > summary:active {
  color: var(--menu-active-fg);
  background-color: var(--menu-active-bg);
  background-size: auto, calc(var(--noise) * 100%);
  background-image: none, var(--fx-noise);
}
.menu :where(li) > *:not(ul, .menu-title, details, .btn):active:not(.menu :where(li) > *:not(ul, .menu-title, details, .btn):active:active), .menu :where(li) > *:not(ul, .menu-title, details, .btn).menu-active:not(.menu :where(li) > *:not(ul, .menu-title, details, .btn).menu-active:active), .menu :where(li) > details > summary:active:not(.menu :where(li) > details > summary:active:active) {
  box-shadow: 0 2px calc(var(--depth) * 3px) -2px var(--menu-active-bg);
}
.menu :where(li).menu-disabled {
  pointer-events: none;
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
}
.menu .dropdown:focus-within .menu-dropdown-toggle:after {
  rotate: 45deg;
  translate: 0 1px;
}
.menu .dropdown-content {
  margin-top: calc(0.25rem * 2);
  padding: calc(0.25rem * 2);
}
.menu .dropdown-content:before {
  display: none;
}
.menu-sm :where(li:not(.menu-title) > *:not(ul, details, .menu-title)), .menu-sm :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
  border-radius: var(--radius-field);
  padding-inline: calc(0.25rem * 2.5);
  padding-block: calc(0.25rem * 1);
  font-size: 0.75rem;
}
.menu-sm .menu-title {
  padding-inline: calc(0.25rem * 3);
  padding-block: calc(0.25rem * 2);
}
.select {
  border: var(--border) solid #0000;
  position: relative;
  display: inline-flex;
  flex-shrink: 1;
  appearance: none;
  align-items: center;
  gap: calc(0.25rem * 1.5);
  background-color: var(--color-base-100);
  padding-inline-start: calc(0.25rem * 4);
  padding-inline-end: calc(0.25rem * 7);
  vertical-align: middle;
  width: clamp(3rem, 20rem, 100%);
  height: var(--size);
  font-size: 0.875rem;
  border-start-start-radius: var(--join-ss, var(--radius-field));
  border-start-end-radius: var(--join-se, var(--radius-field));
  border-end-start-radius: var(--join-es, var(--radius-field));
  border-end-end-radius: var(--join-ee, var(--radius-field));
  background-image: linear-gradient(45deg, #0000 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, #0000 50%);
  background-position: calc(100% - 20px) calc(1px + 50%), calc(100% - 16.1px) calc(1px + 50%);
  background-size: 4px 4px, 4px 4px;
  background-repeat: no-repeat;
  text-overflow: ellipsis;
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
  border-color: var(--input-color);
  --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
  --size: calc(var(--size-field, 0.25rem) * 10);
}
[dir="rtl"] .select {
  background-position: calc(0% + 12px) calc(1px + 50%), calc(0% + 16px) calc(1px + 50%);
}
.select select {
  margin-inline-start: calc(0.25rem * -4);
  margin-inline-end: calc(0.25rem * -7);
  width: calc(100% + 2.75rem);
  appearance: none;
  padding-inline-start: calc(0.25rem * 4);
  padding-inline-end: calc(0.25rem * 7);
  height: calc(100% - 2px);
  background: inherit;
  border-radius: inherit;
  border-style: none;
}
.select select:focus, .select select:focus-within {
  --tw-outline-style: none;
  outline-style: none;
}
@media (forced-colors: active) {

  .select select:focus, .select select:focus-within {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
.select select:not(:last-child) {
  margin-inline-end: calc(0.25rem * -5.5);
  background-image: none;
}
.select:focus, .select:focus-within {
  --input-color: var(--color-base-content);
  box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
  outline: 2px solid var(--input-color);
  outline-offset: 2px;
}
.select:has(> select[disabled]), .select:is(:disabled, [disabled]) {
  cursor: not-allowed;
  border-color: var(--color-base-200);
  background-color: var(--color-base-200);
  color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
}
.select:has(> select[disabled])::placeholder, .select:is(:disabled, [disabled])::placeholder {
  color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
}
.select:has(> select[disabled]) > select[disabled] {
  cursor: not-allowed;
}
.range {
  appearance: none;
  webkit-appearance: none;
  --range-thumb: var(--color-base-100);
  --range-thumb-size: calc(var(--size-selector, 0.25rem) * 6);
  --range-progress: currentColor;
  --range-fill: 1;
  --range-p: 0.25rem;
  --range-bg: color-mix(in oklab, currentColor 10%, #0000);
  cursor: pointer;
  overflow: hidden;
  background-color: transparent;
  vertical-align: middle;
  width: clamp(3rem, 20rem, 100%);
  --radius-selector-max: calc(
    var(--radius-selector) + var(--radius-selector) + var(--radius-selector)
  );
  border-radius: calc(var(--radius-selector) + min(var(--range-p), var(--radius-selector-max)));
  border: none;
  height: var(--range-thumb-size);
}
[dir="rtl"] .range {
  --range-dir: -1;
}
.range:focus {
  outline: none;
}
.range:focus-visible {
  outline: 2px solid;
  outline-offset: 2px;
}
.range::-webkit-slider-runnable-track {
  width: 100%;
  background-color: var(--range-bg);
  border-radius: var(--radius-selector);
  height: calc(var(--range-thumb-size) * 0.5);
}
@media (forced-colors: active) {

  .range::-webkit-slider-runnable-track {
    border: 1px solid;
  }

  .range::-moz-range-track {
    border: 1px solid;
  }
}
.range::-webkit-slider-thumb {
  position: relative;
  box-sizing: border-box;
  border-radius: calc(var(--radius-selector) + min(var(--range-p), var(--radius-selector-max)));
  background-color: currentColor;
  height: var(--range-thumb-size);
  width: var(--range-thumb-size);
  border: var(--range-p) solid;
  appearance: none;
  webkit-appearance: none;
  top: 50%;
  color: var(--range-progress);
  transform: translateY(-50%);
  box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000), 0 0 0 2rem var(--range-thumb) inset, calc((var(--range-dir, 1) * -100rem) - (var(--range-dir, 1) * var(--range-thumb-size) / 2)) 0 0 calc(100rem * var(--range-fill));
}
.range::-moz-range-track {
  width: 100%;
  background-color: var(--range-bg);
  border-radius: var(--radius-selector);
  height: calc(var(--range-thumb-size) * 0.5);
}
.range::-moz-range-thumb {
  position: relative;
  box-sizing: border-box;
  border-radius: calc(var(--radius-selector) + min(var(--range-p), var(--radius-selector-max)));
  background-color: currentColor;
  height: var(--range-thumb-size);
  width: var(--range-thumb-size);
  border: var(--range-p) solid;
  top: 50%;
  color: var(--range-progress);
  box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000), 0 0 0 2rem var(--range-thumb) inset, calc((var(--range-dir, 1) * -100rem) - (var(--range-dir, 1) * var(--range-thumb-size) / 2)) 0 0 calc(100rem * var(--range-fill));
}
.range:disabled {
  cursor: not-allowed;
  opacity: 30%;
}
.alert {
  display: grid;
  align-items: center;
  gap: calc(0.25rem * 4);
  border-radius: var(--radius-box);
  padding-inline: calc(0.25rem * 4);
  padding-block: calc(0.25rem * 3);
  color: var(--color-base-content);
  background-color: var(--alert-color, var(--color-base-200));
  justify-content: start;
  justify-items: start;
  grid-auto-flow: column;
  grid-template-columns: auto;
  text-align: start;
  border: var(--border) solid var(--color-base-200);
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-size: auto, calc(var(--noise) * 100%);
  background-image: none, var(--fx-noise);
  box-shadow: 0 3px 0 -2px oklch(100% 0 0 / calc(var(--depth) * 0.08)) inset, 0 1px color-mix( in oklab, color-mix(in oklab, #000 20%, var(--alert-color, var(--color-base-200))) calc(var(--depth) * 20%), #0000 ), 0 4px 3px -2px oklch(0% 0 0 / calc(var(--depth) * 0.08));
}
.alert:has(:nth-child(2)) {
  grid-template-columns: auto minmax(auto, 1fr);
}
.alert.alert-outline {
  background-color: transparent;
  color: var(--alert-color);
  box-shadow: none;
  background-image: none;
}
.alert.alert-dash {
  background-color: transparent;
  color: var(--alert-color);
  border-style: dashed;
  box-shadow: none;
  background-image: none;
}
.alert.alert-soft {
  color: var(--alert-color, var(--color-base-content));
  background: color-mix( in oklab, var(--alert-color, var(--color-base-content)) 8%, var(--color-base-100) );
  border-color: color-mix( in oklab, var(--alert-color, var(--color-base-content)) 10%, var(--color-base-100) );
  box-shadow: none;
  background-image: none;
}
.chat {
  display: grid;
  column-gap: calc(0.25rem * 3);
  padding-block: calc(0.25rem * 1);
}
.modal {
  pointer-events: none;
  visibility: hidden;
  position: fixed;
  inset: calc(0.25rem * 0);
  margin: calc(0.25rem * 0);
  display: grid;
  height: 100%;
  max-height: none;
  width: 100%;
  max-width: none;
  align-items: center;
  justify-items: center;
  background-color: transparent;
  padding: calc(0.25rem * 0);
  color: inherit;
  overflow-x: hidden;
  transition: transform 0.3s ease-out, visibility 0.3s allow-discrete, background-color 0.3s ease-out, opacity 0.1s ease-out;
  overflow-y: hidden;
  overscroll-behavior: contain;
  z-index: 999;
}
.modal::backdrop {
  display: none;
}
.modal.modal-open, .modal[open], .modal:target {
  background-color: oklch(0% 0 0/ 0.4);
  transition: transform 0.3s ease-out, background-color 0.3s ease-out, opacity 0.1s ease-out;
  pointer-events: auto;
  visibility: visible;
  opacity: 100%;
}
.modal.modal-open .modal-box, .modal[open] .modal-box, .modal:target .modal-box {
  translate: 0 0;
  scale: 1;
  opacity: 1;
}
@starting-style {

  .modal.modal-open, .modal[open], .modal:target {
    visibility: hidden;
    opacity: 0%;
  }
}
.modal-toggle:checked + .modal {
  pointer-events: auto;
  visibility: visible;
  opacity: 100%;
  background-color: oklch(0% 0 0/ 0.4);
}
.modal-toggle:checked + .modal .modal-box {
  translate: 0 0;
  scale: 1;
  opacity: 1;
}
@starting-style {

  .modal-toggle:checked + .modal {
    visibility: hidden;
    opacity: 0%;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.bottom-full {
  bottom: 100%;
}
.left-1\\/2 {
  left: 50%;
}
.left-2\\.5 {
  left: 0.625rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-5 {
  top: 1.25rem;
}
.top-full {
  top: 100%;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.z-\\[1\\] {
  z-index: 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[clamp\\(20ch\\2c 80ch\\2c 80vw\\)\\] {
  max-width: clamp(20ch,80ch,80vw);
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes fadeIn {

  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}
@keyframes fadeOut {

  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
.animate-fade-out {
  animation: fadeOut 0.5s ease-out forwards;
}
@keyframes fadeIn {

  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadeIn {
  animation: fadeIn 0.5s ease-out forwards;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-help {
  cursor: help;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-box {
  border-radius: var(--radius-box);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}
.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/40 {
  border-color: rgb(59 130 246 / 0.4);
}
.border-glass-border {
  border-color: rgba(0, 0, 0, 0.08);
}
.border-glass-shine {
  border-color: rgba(0, 0, 0, 0.05);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-primary\\/20 {
  border-color: rgb(99 102 241 / 0.2);
}
.border-primary\\/30 {
  border-color: rgb(99 102 241 / 0.3);
}
.border-primary\\/50 {
  border-color: rgb(99 102 241 / 0.5);
}
.border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-amber-500\\/30 {
  background-color: rgb(245 158 11 / 0.3);
}
.bg-background-input {
  background-color: rgba(0, 0, 0, 0.05);
}
.bg-background-primary {
  background-color: rgba(255, 255, 255, 0.9);
}
.bg-background-primary\\/70 {
  background-color: rgba(255, 255, 255, 0.7);
}
.bg-background-secondary {
  background-color: rgba(245, 245, 250, 0.8);
}
.bg-background-secondary\\/40 {
  background-color: rgba(245, 245, 250, 0.4);
}
.bg-background-secondary\\/70 {
  background-color: rgba(245, 245, 250, 0.7);
}
.bg-background-secondary\\/80 {
  background-color: rgba(245, 245, 250, 0.8);
}
.bg-background-tertiary {
  background-color: rgba(235, 235, 245, 0.85);
}
.bg-background-tertiary\\/50 {
  background-color: rgba(235, 235, 245, 0.5);
}
.bg-base-100 {
  background-color: var(--color-base-100);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/20 {
  background-color: rgb(37 99 235 / 0.2);
}
.bg-fuchsia-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-primary\\/10 {
  background-color: rgb(99 102 241 / 0.1);
}
.bg-primary\\/20 {
  background-color: rgb(99 102 241 / 0.2);
}
.bg-purple-500\\/10 {
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-light {
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-400 {
  --tw-gradient-to: #60a5fa var(--tw-gradient-to-position);
}
.to-blue-700 {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-700 {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-secondary {
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-fuchsia-500 {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.text-text-primary {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.accent-primary {
  accent-color: #6366f1;
}
.opacity-0 {
  opacity: 0;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-\\[0\\.025\\] {
  opacity: 0.025;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-glass {
  --tw-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.rounded-box {
  border-radius: var(--radius-box);
}
:root .prose {
  --tw-prose-body: color-mix(in oklab, var(--color-base-content) 80%, #0000);
  --tw-prose-headings: var(--color-base-content);
  --tw-prose-lead: var(--color-base-content);
  --tw-prose-links: var(--color-base-content);
  --tw-prose-bold: var(--color-base-content);
  --tw-prose-counters: var(--color-base-content);
  --tw-prose-bullets: color-mix(in oklab, var(--color-base-content) 50%, #0000);
  --tw-prose-hr: color-mix(in oklab, var(--color-base-content) 20%, #0000);
  --tw-prose-quotes: var(--color-base-content);
  --tw-prose-quote-borders: color-mix(in oklab, var(--color-base-content) 20%, #0000);
  --tw-prose-captions: color-mix(in oklab, var(--color-base-content) 50%, #0000);
  --tw-prose-code: var(--color-base-content);
  --tw-prose-pre-code: var(--color-neutral-content);
  --tw-prose-pre-bg: var(--color-neutral);
  --tw-prose-th-borders: color-mix(in oklab, var(--color-base-content) 50%, #0000);
  --tw-prose-td-borders: color-mix(in oklab, var(--color-base-content) 20%, #0000);
  --tw-prose-kbd: color-mix(in oklab, var(--color-base-content) 80%, #0000);
}
:root .prose :where(code):not(pre > code) {
  background-color: var(--color-base-200);
  border-radius: var(--radius-selector);
  border: var(--border) solid var(--color-base-300);
  padding-inline: 0.5em;
  font-weight: inherit;
}
:root .prose :where(code):not(pre > code):before, :root .prose :where(code):not(pre > code):after {
  display: none;
}
.join {
  display: inline-flex;
  align-items: stretch;
  --join-ss: 0;
  --join-se: 0;
  --join-es: 0;
  --join-ee: 0;
}
.join :where(.join-item) {
  border-start-start-radius: var(--join-ss, 0);
  border-start-end-radius: var(--join-se, 0);
  border-end-start-radius: var(--join-es, 0);
  border-end-end-radius: var(--join-ee, 0);
}
.join :where(.join-item) * {
  --join-ss: var(--radius-field);
  --join-se: var(--radius-field);
  --join-es: var(--radius-field);
  --join-ee: var(--radius-field);
}
.join > .join-item:where(:first-child) {
  --join-ss: var(--radius-field);
  --join-se: 0;
  --join-es: var(--radius-field);
  --join-ee: 0;
}
.join :first-child:not(:last-child) :where(.join-item) {
  --join-ss: var(--radius-field);
  --join-se: 0;
  --join-es: var(--radius-field);
  --join-ee: 0;
}
.join > .join-item:where(:last-child) {
  --join-ss: 0;
  --join-se: var(--radius-field);
  --join-es: 0;
  --join-ee: var(--radius-field);
}
.join :last-child:not(:first-child) :where(.join-item) {
  --join-ss: 0;
  --join-se: var(--radius-field);
  --join-es: 0;
  --join-ee: var(--radius-field);
}
.join > .join-item:where(:only-child) {
  --join-ss: var(--radius-field);
  --join-se: var(--radius-field);
  --join-es: var(--radius-field);
  --join-ee: var(--radius-field);
}
.join :only-child :where(.join-item) {
  --join-ss: var(--radius-field);
  --join-se: var(--radius-field);
  --join-es: var(--radius-field);
  --join-ee: var(--radius-field);
}

:root {
    --bg-primary: rgba(14, 14, 22, 0.8);
    --bg-secondary: rgba(22, 22, 38, 0.7);
    --bg-tertiary: rgba(28, 28, 48, 0.75);
    --bg-input: rgba(255, 255, 255, 0.07);
    --accent-primary: #6366f1;
    --accent-secondary: #8b5cf6;
    --accent-glow: rgba(147, 112, 219, 0.5);
    --text-primary: #f8fafc;
    --text-secondary: #cbd5e1;
    --text-tertiary: #94a3b8;
    --transition-fast: 0.15s ease;
    --transition-normal: 0.3s ease;
    --shadow-sm: 0 2px 10px rgba(0, 0, 0, 0.2);
    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.3);
    --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.4);
    --border-radius-sm: 0.75rem;
    --border-radius-md: 1rem;
    --border-radius-lg: 1.25rem;
    --border-radius-xl: 1.5rem;
    --border-radius-pill: 9999px;
    --glass-border: 1px solid rgba(255, 255, 255, 0.08);
    --glass-shine: linear-gradient(120deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.1));
}

body {
    margin: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: rgba(20, 12, 36, 0.3);
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, var(--accent-secondary), var(--accent-primary));
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(to bottom, #9333ea, #4f46e5);
}

/* Gradient text utility */
.gradient-text {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
  background-clip: text;
  color: transparent;
}

/* Glass morphism effects */
.glass {
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  background-color: rgba(245, 245, 250, 0.7);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.glass-input {
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  background-color: rgba(0, 0, 0, 0.05);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.glass-input:focus {
  border-color: rgb(99 102 241 / 0.5);
  --tw-shadow: 0 0 15px rgba(147, 112, 219, 0.3);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* --- Animation Styles --- */

/* New Shimmer Animation */
@keyframes shimmer {
    0% {
        background-position: -200% 0;
        opacity: 0.85;
    }

    50% {
        opacity: 1;
    }

    100% {
        background-position: 200% 0;
        opacity: 0.85;
    }
}

/* Class to apply the shimmer effect to text */
.shimmer-text {
    font-weight: 600;
    background: linear-gradient(90deg,
            rgba(200, 200, 220, 0.8) 0%,
            rgba(99, 102, 241, 1) 25%,
            rgba(139, 92, 246, 1) 50%,
            rgba(99, 102, 241, 1) 75%,
            rgba(200, 200, 220, 0.8) 100%);
    background-size: 200% auto;
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    animation: shimmer 2s linear infinite;
    display: inline-block;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
}

/* --- Container Styles --- */

/* Reasoning Process Container */
.thinking-container {
    margin-top: 8px;
    margin-bottom: 12px;
    transition: all 0.3s ease;
    padding: 10px 16px;
    border-radius: 8px;
}

/* Style for the ACTIVE thinking state (no box) */
.thinking-container.active {
    background-color: transparent;
    border: none;
    padding: 0;
    margin-bottom: 10px;
}

/* Style for COMPLETED thinking state */
.thinking-container.completed {
    background-color: rgba(99, 102, 241, 0.1);
    border: 1px solid rgba(99, 102, 241, 0.3);
    padding: 10px 16px;
}

/* Styles for content visibility */
.thinking-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease, opacity 0.3s ease;
    opacity: 0;
}

.thinking-content.visible {
    max-height: 500px;
    overflow-y: auto;
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid rgba(99, 102, 241, 0.2);
    opacity: 1;
}

/* Toggle button styling */
.thinking-toggle {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.85rem;
    color: rgba(200, 200, 220, 0.8);
}

.thinking-toggle:hover {
    color: rgba(255, 255, 255, 0.9);
}

.thinking-time {
    font-size: 0.75rem;
    color: rgba(139, 92, 246, 0.8);
    font-weight: 500;
}

/* Searching Process Container */
.searching-container {
    margin-top: 8px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    padding: 8px 12px;
    background-color: rgba(59, 130, 246, 0.1);
    border: 1px solid rgba(59, 130, 246, 0.2);
    border-radius: 8px;
}

.searching-container.active {
    background-color: rgba(59, 130, 246, 0.1);
    border: 1px solid rgba(59, 130, 246, 0.2);
}

.searching-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.85rem;
    color: rgba(180, 210, 240, 0.8);
}

.searching-animation-globe {
    display: none;
}

/* Optional: Styles for expandable search content */
.searching-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease, opacity 0.3s ease;
    opacity: 0;
}

.searching-content.visible {
    max-height: 500px;
    overflow-y: auto;
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid rgba(66, 135, 245, 0.2);
    opacity: 1;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 10px;
}

.hover\\:border-glass-shine:hover {
  border-color: rgba(0, 0, 0, 0.05);
}

.hover\\:bg-background-secondary:hover {
  background-color: rgba(245, 245, 250, 0.8);
}

.hover\\:bg-background-tertiary:hover {
  background-color: rgba(235, 235, 245, 0.85);
}

.hover\\:bg-background-tertiary\\/50:hover {
  background-color: rgba(235, 235, 245, 0.5);
}

.hover\\:bg-background-tertiary\\/70:hover {
  background-color: rgba(235, 235, 245, 0.7);
}

.hover\\:bg-blue-500\\/20:hover {
  background-color: rgb(59 130 246 / 0.2);
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-fuchsia-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary\\/20:hover {
  background-color: rgb(99 102 241 / 0.2);
}

.hover\\:bg-purple-500\\/20:hover {
  background-color: rgb(168 85 247 / 0.2);
}

.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}

.hover\\:bg-red-500\\/30:hover {
  background-color: rgb(239 68 68 / 0.3);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:from-indigo-600:hover {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-purple-600:hover {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow-glow:hover {
  --tw-shadow: 0 0 15px rgba(147, 112, 219, 0.3);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.dark\\:border-\\[\\#3d3d3d\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(61 61 61 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-dark-glass-border:is(.dark *) {
  border-color: rgba(255, 255, 255, 0.08);
}

.dark\\:border-dark-glass-shine:is(.dark *) {
  border-color: rgba(255, 255, 255, 0.1);
}

.dark\\:border-dark-primary:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.dark\\:border-dark-primary\\/30:is(.dark *) {
  border-color: rgb(99 102 241 / 0.3);
}

.dark\\:border-gray-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}

.dark\\:border-primary\\/40:is(.dark *) {
  border-color: rgb(99 102 241 / 0.4);
}

.dark\\:border-purple-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.dark\\:bg-\\[\\#252525\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 37 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-500\\/20:is(.dark *) {
  background-color: rgb(59 130 246 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-dark-background-input:is(.dark *) {
  background-color: rgba(255, 255, 255, 0.07);
}

.dark\\:bg-dark-background-primary:is(.dark *) {
  background-color: rgba(14, 14, 22, 0.8);
}

.dark\\:bg-dark-background-primary\\/70:is(.dark *) {
  background-color: rgba(14, 14, 22, 0.7);
}

.dark\\:bg-dark-background-secondary:is(.dark *) {
  background-color: rgba(22, 22, 38, 0.7);
}

.dark\\:bg-dark-background-secondary\\/60:is(.dark *) {
  background-color: rgba(22, 22, 38, 0.6);
}

.dark\\:bg-dark-background-secondary\\/80:is(.dark *) {
  background-color: rgba(22, 22, 38, 0.8);
}

.dark\\:bg-dark-background-tertiary:is(.dark *) {
  background-color: rgba(28, 28, 48, 0.75);
}

.dark\\:bg-dark-background-tertiary\\/50:is(.dark *) {
  background-color: rgba(28, 28, 48, 0.5);
}

.dark\\:bg-dark-primary\\/20:is(.dark *) {
  background-color: rgb(99 102 241 / 0.2);
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700\\/50:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-purple-500\\/20:is(.dark *) {
  background-color: rgb(168 85 247 / 0.2);
}

.dark\\:bg-red-500\\/20:is(.dark *) {
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-dark-primary:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.dark\\:text-dark-text-primary:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-dark-text-secondary:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder-gray-400:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}

.dark\\:opacity-\\[0\\.025\\]:is(.dark *) {
  opacity: 0.025;
}

.dark\\:hover\\:border-dark-glass-shine:hover:is(.dark *) {
  border-color: rgba(255, 255, 255, 0.1);
}

.dark\\:hover\\:bg-blue-500\\/30:hover:is(.dark *) {
  background-color: rgb(59 130 246 / 0.3);
}

.dark\\:hover\\:bg-dark-background-secondary:hover:is(.dark *) {
  background-color: rgba(22, 22, 38, 0.7);
}

.dark\\:hover\\:bg-dark-background-tertiary:hover:is(.dark *) {
  background-color: rgba(28, 28, 48, 0.75);
}

.dark\\:hover\\:bg-dark-background-tertiary\\/50:hover:is(.dark *) {
  background-color: rgba(28, 28, 48, 0.5);
}

.dark\\:hover\\:bg-dark-background-tertiary\\/70:hover:is(.dark *) {
  background-color: rgba(28, 28, 48, 0.7);
}

.dark\\:hover\\:bg-dark-primary\\/20:hover:is(.dark *) {
  background-color: rgb(99 102 241 / 0.2);
}

.dark\\:hover\\:bg-dark-primary\\/30:hover:is(.dark *) {
  background-color: rgb(99 102 241 / 0.3);
}

.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-purple-500\\/30:hover:is(.dark *) {
  background-color: rgb(168 85 247 / 0.3);
}

.dark\\:hover\\:bg-red-500\\/30:hover:is(.dark *) {
  background-color: rgb(239 68 68 / 0.3);
}

.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:hover\\:text-purple-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-dark-primary:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:ring-dark-primary:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

@media (min-width: 768px) {

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd,iCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd,8CAAc;EAAd,wCAAc;EAAd,iDAAc;EAAd,2CAAc;EAAd,mDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,qCAAc;EAAd,8CAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,sCAAc;EAAd,8CAAc;EAAd,yBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,aAAc;EAAd,UAAc;EAAd;AAAc;;AAAd;;EAAA;IAAA,kBAAc;IAAd,4CAAc;IAAd,2CAAc;IAAd,4CAAc;IAAd,kDAAc;IAAd,yCAAc;IAAd,iDAAc;IAAd,2CAAc;IAAd,mDAAc;IAAd,wCAAc;IAAd,gDAAc;IAAd,yCAAc;IAAd,gDAAc;IAAd,qCAAc;IAAd,8CAAc;IAAd,yCAAc;IAAd,gDAAc;IAAd,wCAAc;IAAd,gDAAc;IAAd,sCAAc;IAAd,8CAAc;IAAd,yBAAc;IAAd,uBAAc;IAAd,oBAAc;IAAd,wBAAc;IAAd,qBAAc;IAAd,aAAc;IAAd,UAAc;IAAd;EAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd,iCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd,8CAAc;EAAd,wCAAc;EAAd,iDAAc;EAAd,2CAAc;EAAd,mDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,qCAAc;EAAd,8CAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,sCAAc;EAAd,8CAAc;EAAd,yBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,aAAc;EAAd,UAAc;EAAd;AAAc;;AAAd;EAAA,kBAAc;EAAd,4CAAc;EAAd,2CAAc;EAAd,4CAAc;EAAd,kDAAc;EAAd,yCAAc;EAAd,iDAAc;EAAd,2CAAc;EAAd,mDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,qCAAc;EAAd,8CAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,wCAAc;EAAd,gDAAc;EAAd,sCAAc;EAAd,8CAAc;EAAd,yBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,aAAc;EAAd,UAAc;EAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,uDAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,+EAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,+BAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB,yCAAoB;EAApB,iCAAoB;EAApB,yDAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,8BAAoB;EAApB,sBAAoB;EAApB,8CAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,yBAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,gCAAoB;EAApB,oEAAoB;EAApB,gCAAoB;AAAA;AAApB;EAAA,8GAAoB;EAApB,qBAAoB;EAApB,0BAAoB;EAApB,2CAAoB;AAAA;AAApB;;EAAA;IAAA,6BAAoB;IAApB,8GAAoB;IAApB,qBAAoB;IAApB,0BAAoB;IAApB;EAAoB;;EAApB;IAAA,gCAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA,gCAAoB;IAApB;EAAoB;;EAApB;IAAA,gCAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,wBAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,4BAAoB;EAApB,oBAAoB;EAApB,+BAAoB;EAApB,mBAAoB;EAApB,oCAAoB;EAApB,gBAAoB;EAApB,0DAAoB;EAApB,sEAAoB;EAApB,sDAAoB;EAApB,yBAAoB;EAApB,8DAAoB;EAApB,4DAAoB;EAApB,4DAAoB;EAApB,0DAAoB;EAApB,+BAAoB;EAApB,gDAAoB;EAApB,wCAAoB;EAApB,2BAAoB;EAApB,mBAAoB;EAApB,+BAAoB;EAApB,gEAAoB;EAApB,8FAAoB;EAApB,6CAAoB;EAApB,iDAAoB;EAApB,mCAAoB;EAApB,aAAoB;EAApB,8EAAoB;EAApB;qFAAoB;EAApB,4BAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,+EAAoB;EAApB,mFAAoB;EAApB;AAAoB;AAApB;EAAA,iFAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,oBAAoB;IAApB,4EAAoB;IAApB,mBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,iCAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,iBAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,mCAAoB;EAApB,iCAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,aAAoB;EAApB,QAAoB;EAApB,sEAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,QAAoB;EAApB,eAAoB;EAApB,gCAAoB;EAApB,wBAAoB;EAApB,iCAAoB;EAApB;AAAoB;AAApB;EAAA,QAAoB;EAApB,eAAoB;EAApB,gCAAoB;EAApB,wBAAoB;EAApB,iCAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,4CAAoB;EAApB,6BAAoB;EAApB,+BAAoB;EAApB,yBAAoB;EAApB,2BAAoB;EAApB,8BAAoB;EAApB,iCAAoB;EAApB,kDAAoB;EAApB,4CAAoB;EAApB,iCAAoB;EAApB,8BAAoB;EAApB,0CAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,yEAAoB;EAApB,uEAAoB;EAApB,uEAAoB;EAApB,qEAAoB;EAApB,2CAAoB;EAApB,mKAAoB;EAApB,wDAAoB;EAApB,mFAAoB;AAAA;AAApB;EAAA,YAAoB;EAApB,iCAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,uCAAoB;EAApB,iCAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,+BAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,8DAAoB;EAApB,4DAAoB;EAApB,4DAAoB;EAApB,0DAAoB;EAApB,gCAAoB;EAApB,wJAAoB;EAApB,6CAAoB;EAApB,wEAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,uBAAoB;EAApB,sBAAoB;EAApB,2BAAoB;EAApB,wCAAoB;EAApB,uBAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,6BAAoB;EAApB,YAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB,8BAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB,8BAAoB;AAAA;AAApB;;EAAA;IAAA,yCAAoB;IAApB;EAAoB;;EAApB;IAAA,8BAAoB;IAApB;EAAoB;;EAApB;IAAA,yCAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mDAAoB;EAApB,oGAAoB;EAApB,gDAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,wCAAoB;EAApB,yFAAoB;EAApB,qCAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mDAAoB;EAApB,oGAAoB;EAApB,gDAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB,8CAAoB;EAApB,kDAAoB;EAApB,iFAAoB;AAAA;AAApB;EAAA,mBAAoB;EAApB,mCAAoB;EAApB,uCAAoB;EAApB,sEAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,8CAAoB;EAApB,kDAAoB;EAApB,iFAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,2CAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,mCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,cAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB,yDAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,2BAAoB;EAApB,mBAAoB;EAApB,iCAAoB;EAApB,mBAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,sCAAoB;EAApB,8BAAoB;EAApB,4CAAoB;EAApB,8BAAoB;EAApB,6BAAoB;AAAA;AAApB;EAAA,uCAAoB;EAApB,oCAAoB;EAApB;AAAoB;AAApB;EAAA,kDAAoB;EAApB,+CAAoB;EAApB;AAAoB;AAApB;EAAA,sCAAoB;EAApB,qCAAoB;EAApB;AAAoB;AAApB;EAAA,iDAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,mBAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,qCAAoB;EAApB,iFAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,sBAAoB;EAApB,gDAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,sGAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,4BAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,gCAAoB;EAApB,oCAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,WAAoB;EAApB,iBAAoB;EAApB,qBAAoB;EAApB,gCAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,UAAoB;EAApB,qBAAoB;EAApB,gCAAoB;EAApB,gCAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,4BAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,WAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,+BAAoB;EAApB,6CAAoB;EAApB,wBAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,YAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAoB;EAApB,kEAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,qBAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,wBAAoB;EAApB,4CAAoB;EAApB,mCAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,UAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,cAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA,aAAoB;IAApB,qBAAoB;IAApB,WAAoB;IAApB;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,qBAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,kCAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,SAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,SAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,SAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,sBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,qCAAoB;EAApB,kBAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,gCAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,4CAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kCAAoB;EAApB,+BAAoB;EAApB,kBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,yGAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,qCAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,gCAAoB;EAApB,4FAAoB;EAApB,kDAAoB;EAApB,+CAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,gDAAoB;EAApB,uCAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,0BAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,YAAoB;EAApB,aAAoB;EAApB,8BAAoB;EAApB,WAAoB;EAApB,qEAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,0EAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,mDAAoB;EAApB;AAAoB;AAApB;EAAA,2CAAoB;EAApB,0IAAoB;AAAA;AAApB;EAAA,wEAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,YAAoB;IAApB,6BAAoB;IAApB,kBAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA,YAAoB;IAApB,6BAAoB;IAApB,kBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,YAAoB;EAApB,aAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,UAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,wCAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,kCAAoB;EAApB;;GAAoB;EAApB,iJAAoB;EAApB,wBAAoB;EAApB,yFAAoB;EAApB,kDAAoB;EAApB,wEAAoB;EAApB,qBAAoB;EAApB,+CAAoB;EAApB,sEAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,UAAoB;EAApB,4BAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,YAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,qCAAoB;EAApB,YAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,4BAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qCAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB,YAAoB;EAApB,qCAAoB;EAApB,8BAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB,0EAAoB;EAApB,yMAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,sCAAoB;IAApB,kBAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA,sBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,kCAAoB;EAApB,uCAAoB;EAApB,wCAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,YAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB;AAAoB;AAApB;EAAA,4CAAoB;EAApB,yCAAoB;EAApB,yBAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,kDAAoB;EAApB,2CAAoB;EAApB,iCAAoB;EAApB,0CAAoB;EAApB,wCAAoB;EAApB,sCAAoB;EAApB,8BAAoB;EAApB,2CAAoB;EAApB,mKAAoB;EAApB,mFAAoB;AAAA;AAApB;EAAA,iCAAoB;EAApB,8BAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,kCAAoB;EAApB,uCAAoB;EAApB,gCAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,2BAAoB;EAApB,mBAAoB;EAApB,gCAAoB;EAApB,wJAAoB;EAApB,wEAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,wCAAoB;EAApB,uBAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,6BAAoB;EAApB,YAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB,8BAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB,8BAAoB;AAAA;AAApB;;EAAA;IAAA,yCAAoB;IAApB;EAAoB;;EAApB;IAAA,8BAAoB;IAApB;EAAoB;;EAApB;IAAA,yCAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,mDAAoB;EAApB,oGAAoB;EAApB,gDAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,wCAAoB;EAApB,yFAAoB;EAApB,qCAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mDAAoB;EAApB,oGAAoB;EAApB,gDAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB,8CAAoB;EAApB,kDAAoB;EAApB,iFAAoB;AAAA;AAApB;EAAA,mBAAoB;EAApB,mCAAoB;EAApB,uCAAoB;EAApB,sEAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,8CAAoB;EAApB,kDAAoB;EAApB,iFAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,UAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,2BAAoB;EAApB,iCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,8BAAoB;EAApB,iCAAoB;EAApB,2BAAoB;EAApB,kDAAoB;EAApB,kCAAoB;EAApB,8BAAoB;EAApB,6BAAoB;EAApB,yBAAoB;AAAA;AAApB;EAAA,mBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB,uCAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,cAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,mCAAoB;EAApB,oCAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,UAAoB;IAApB;EAAoB;;EAApB;IAAA,QAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB,0BAAoB;EAApB,8CAAoB;EAApB,sCAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,sCAAoB;EAApB,uCAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,qCAAoB;EAApB,sBAAoB;EAApB,yBAAoB;EAApB,2CAAoB;EAApB,YAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,kCAAoB;EAApB,iCAAoB;EAApB,kCAAoB;EAApB,iBAAoB;EAApB,wDAAoB;EAApB,yBAAoB;EAApB,sDAAoB;EAApB,6DAAoB;EAApB,kBAAoB;EAApB,yBAAoB;UAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,eAAoB;EAApB,iBAAoB;EAApB,sCAAoB;EAApB,yBAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,iFAAoB;EAApB,gCAAoB;EAApB,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,eAAoB;EAApB,iFAAoB;EAApB,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,2CAAoB;EAApB,YAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,4BAAoB;EAApB,uCAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,0BAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,kCAAoB;EAApB,mCAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,wBAAoB;EAApB,uCAAoB;EAApB,uCAAoB;EAApB,qCAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,8DAAoB;EAApB,4DAAoB;EAApB,4DAAoB;EAApB,0DAAoB;EAApB,2HAAoB;EAApB,2FAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,wJAAoB;EAApB,gCAAoB;EAApB,wEAAoB;EAApB,6CAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,uCAAoB;EAApB,qCAAoB;EAApB,2BAAoB;EAApB,gBAAoB;EAApB,uCAAoB;EAApB,qCAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,mBAAoB;AAAA;AAApB;;EAAA;IAAA,8BAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,uCAAoB;EAApB;AAAoB;AAApB;EAAA,wCAAoB;EAApB,yFAAoB;EAApB,qCAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,mCAAoB;EAApB,uCAAoB;EAApB,sEAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,uBAAoB;EAApB,oCAAoB;EAApB,2DAAoB;EAApB,8BAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,wDAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,6BAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB;;GAAoB;EAApB,6FAAoB;EAApB,YAAoB;EAApB,+BAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,iCAAoB;EAApB,qCAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB,6FAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,8BAAoB;EAApB,4BAAoB;EAApB,gBAAoB;EAApB,uBAAoB;EAApB,QAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,iCAAoB;EAApB,qCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB,6FAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,8BAAoB;EAApB,4BAAoB;EAApB,QAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,gCAAoB;EAApB,iCAAoB;EAApB,gCAAoB;EAApB,gCAAoB;EAApB,2DAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,sBAAoB;EAApB,2BAAoB;EAApB,iBAAoB;EAApB,iDAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,gDAAoB;EAApB,uCAAoB;EAApB,2QAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,6BAAoB;EAApB,yBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,yBAAoB;EAApB,oBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,oDAAoB;EAApB,0GAAoB;EAApB,6GAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB,6BAAoB;EAApB,0BAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,0HAAoB;EAApB,kBAAoB;EAApB,4BAAoB;EAApB,YAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oCAAoB;EAApB,0FAAoB;EAApB,oBAAoB;EAApB,mBAAoB;EAApB,aAAoB;AAAA;AAApB;EAAA,cAAoB;EAApB,QAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,kBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,aAAoB;EAApB,oCAAoB;AAAA;AAApB;EAAA,cAAoB;EAApB,QAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,kBAAoB;IAApB;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8CAAmB;EAAnB,0CAAmB;EAAnB,2CAAmB;EAAnB,0CAAmB;EAAnB,8CAAmB;EAAnB,6EAAmB;EAAnB,wEAAmB;EAAnB,4CAAmB;EAAnB,mFAAmB;EAAnB,8EAAmB;EAAnB,0CAAmB;EAAnB,iDAAmB;EAAnB,uCAAmB;EAAnB,gFAAmB;EAAnB,gFAAmB;EAAnB,yEAAmB;AAAA;AAAnB;EAAA,uCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,qBAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,oBAAmB;EAAnB,YAAmB;EAAnB,YAAmB;EAAnB,YAAmB;EAAnB,YAAmB;AAAA;AAAnB;EAAA,4CAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,wCAAmB;AAAA;AAAnB;EAAA,8BAAmB;EAAnB,8BAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,YAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,YAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB,8BAAmB;EAAnB,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB,8BAAmB;EAAnB,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,8BAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,8BAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;;AAEnB;IACI,mCAAmC;IACnC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,uCAAuC;IACvC,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,mDAAmD;IACnD,kHAAkH;AACtH;;AAEA;IACI,SAAS;IACT,iJAAiJ;IACjJ,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA,yCAAyC;AACzC;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,sFAAsF;IACtF,mBAAmB;AACvB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA,0BAA0B;AAEtB;EAAA,qEAA+E;EAA/E,4DAA+E;EAA/E,oEAA+E;EAA/E,mEAA+E;EAA/E,wDAA+E;EAA/E,qBAA+E;EAA/E;AAA+E;;AAGnF,2BAA2B;AAEvB;EAAA,iBAA6E;EAA7E,iCAA6E;EAA7E,0CAA6E;EAA7E,6BAA6E;EAA7E;AAA6E;;AAI7E;EAAA,iBAA8G;EAA9G,iCAA8G;EAA9G,qCAA8G;EAA9G,wBAA8G;EAA9G,wDAA8G;EAA9G;AAA8G;;AAA9G;EAAA,mCAA8G;EAA9G,8CAA8G;EAA9G,oDAA8G;EAA9G;AAA8G;;AAGlH,6BAA6B;;AAE7B,0BAA0B;AAC1B;IACI;QACI,4BAA4B;QAC5B,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,2BAA2B;QAC3B,aAAa;IACjB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,gBAAgB;IAChB;;;;;0CAKsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,6BAA6B;;AAE7B,gCAAgC;AAChC;IACI,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,iDAAiD;AACjD;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,yCAAyC;IACzC,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,yCAAyC;IACzC,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAzNA;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,4DAyNC;EAzND,mEAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,8CAyNC;EAzND,oDAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,8BAyNC;EAzND;AAyNC;;AAzND;EAAA,2GAyNC;EAzND,yGAyNC;EAzND;AAyNC;;AAzND;EAAA,2GAyNC;EAzND,yGAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,2BAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA,kBAyNC;EAzND;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;EAAA,sBAyNC;EAzND;AAyNC;;AAzND;EAAA,oBAyNC;EAzND;AAyNC;;AAzND;;EAAA;IAAA;EAyNC;;EAzND;IAAA,mBAyNC;IAzND;EAyNC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n    --bg-primary: rgba(14, 14, 22, 0.8);\n    --bg-secondary: rgba(22, 22, 38, 0.7);\n    --bg-tertiary: rgba(28, 28, 48, 0.75);\n    --bg-input: rgba(255, 255, 255, 0.07);\n    --accent-primary: #6366f1;\n    --accent-secondary: #8b5cf6;\n    --accent-glow: rgba(147, 112, 219, 0.5);\n    --text-primary: #f8fafc;\n    --text-secondary: #cbd5e1;\n    --text-tertiary: #94a3b8;\n    --transition-fast: 0.15s ease;\n    --transition-normal: 0.3s ease;\n    --shadow-sm: 0 2px 10px rgba(0, 0, 0, 0.2);\n    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.3);\n    --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.4);\n    --border-radius-sm: 0.75rem;\n    --border-radius-md: 1rem;\n    --border-radius-lg: 1.25rem;\n    --border-radius-xl: 1.5rem;\n    --border-radius-pill: 9999px;\n    --glass-border: 1px solid rgba(255, 255, 255, 0.08);\n    --glass-shine: linear-gradient(120deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.1));\n}\n\nbody {\n    margin: 0;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: rgba(20, 12, 36, 0.3);\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: linear-gradient(to bottom, var(--accent-secondary), var(--accent-primary));\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(to bottom, #9333ea, #4f46e5);\n}\n\n/* Gradient text utility */\n.gradient-text {\n    @apply bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent;\n}\n\n/* Glass morphism effects */\n.glass {\n    @apply backdrop-blur-sm bg-background-secondary/70 border border-glass-border;\n}\n\n.glass-input {\n    @apply bg-background-input border border-glass-border focus:border-primary/50 focus:shadow-glow transition-all;\n}\n\n/* --- Animation Styles --- */\n\n/* New Shimmer Animation */\n@keyframes shimmer {\n    0% {\n        background-position: -200% 0;\n        opacity: 0.85;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        background-position: 200% 0;\n        opacity: 0.85;\n    }\n}\n\n/* Class to apply the shimmer effect to text */\n.shimmer-text {\n    font-weight: 600;\n    background: linear-gradient(90deg,\n            rgba(200, 200, 220, 0.8) 0%,\n            rgba(99, 102, 241, 1) 25%,\n            rgba(139, 92, 246, 1) 50%,\n            rgba(99, 102, 241, 1) 75%,\n            rgba(200, 200, 220, 0.8) 100%);\n    background-size: 200% auto;\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n    animation: shimmer 2s linear infinite;\n    display: inline-block;\n    font-size: 0.95rem;\n    letter-spacing: 0.01em;\n}\n\n/* --- Container Styles --- */\n\n/* Reasoning Process Container */\n.thinking-container {\n    margin-top: 8px;\n    margin-bottom: 12px;\n    transition: all 0.3s ease;\n    padding: 10px 16px;\n    border-radius: 8px;\n}\n\n/* Style for the ACTIVE thinking state (no box) */\n.thinking-container.active {\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    margin-bottom: 10px;\n}\n\n/* Style for COMPLETED thinking state */\n.thinking-container.completed {\n    background-color: rgba(99, 102, 241, 0.1);\n    border: 1px solid rgba(99, 102, 241, 0.3);\n    padding: 10px 16px;\n}\n\n/* Styles for content visibility */\n.thinking-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.5s ease, opacity 0.3s ease;\n    opacity: 0;\n}\n\n.thinking-content.visible {\n    max-height: 500px;\n    overflow-y: auto;\n    padding-top: 10px;\n    margin-top: 10px;\n    border-top: 1px solid rgba(99, 102, 241, 0.2);\n    opacity: 1;\n}\n\n/* Toggle button styling */\n.thinking-toggle {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 0.85rem;\n    color: rgba(200, 200, 220, 0.8);\n}\n\n.thinking-toggle:hover {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.thinking-time {\n    font-size: 0.75rem;\n    color: rgba(139, 92, 246, 0.8);\n    font-weight: 500;\n}\n\n/* Searching Process Container */\n.searching-container {\n    margin-top: 8px;\n    margin-bottom: 10px;\n    transition: all 0.3s ease;\n    padding: 8px 12px;\n    background-color: rgba(59, 130, 246, 0.1);\n    border: 1px solid rgba(59, 130, 246, 0.2);\n    border-radius: 8px;\n}\n\n.searching-container.active {\n    background-color: rgba(59, 130, 246, 0.1);\n    border: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.searching-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 0.85rem;\n    color: rgba(180, 210, 240, 0.8);\n}\n\n.searching-animation-globe {\n    display: none;\n}\n\n/* Optional: Styles for expandable search content */\n.searching-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.5s ease, opacity 0.3s ease;\n    opacity: 0;\n}\n\n.searching-content.visible {\n    max-height: 500px;\n    overflow-y: auto;\n    padding-top: 10px;\n    margin-top: 10px;\n    border-top: 1px solid rgba(66, 135, 245, 0.2);\n    opacity: 1;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
